import { CardContent, Divider, Typography,Button } from '@mui/material'
import React, { Component } from 'react'
import { Box } from '@mui/material';
import wyzrTheme from "../styles/customTheme";
import Progress from '../components/ui-components/graphs/Progress';
import Grid from "@mui/material/Grid";
import { offsetProjects } from '../utils/mockData';
import OffsetProjectCard from '../components/ui-components/carbon-footprint/OffsetProjectCard';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CarbonFootprintOffsetList from '../components/ui-components/carbon-footprint/CarbonFootprintOffsetList';
import { Card } from '@mui/material';
import { getURLBase, updateParentHeight } from '../utils/helperFns';
import axios from 'axios';
import Project1 from "../images/project2.jpg";
import Project2 from "../images/project1.jpg";

const images = {
    Project1: Project1,
    Project2: Project2,
}
export default class OffsetCarbonFootprint extends Component {

    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/carbon-footprint/offset";
        this.state = {
            projects: offsetProjects,
            showList:false,
            isReady:true,
            progressStart: 0,
            progressEnd: 0
        };
    }

    componentDidMount() {
        axios.post(this.url, { gid: this.props.gid }).then(
            (response) => {
                this.setState({
                    projects: response.data.body.projects,
                    progressStart: response.data.body.progressStart,
                    progressEnd: response.data.body.progressEnd,
                    isReady:true,
                })
            }
        )
    }

    openOffsetList = () => {
        var s = this.state;
        s.showList = !s.showList;
        this.setState({s}, () => {
            updateParentHeight("parent_OffsetCarbonFootprint","child_CarbonFootprintOffsetList",this.state.showList)
        });
    }

    render() {

        return (
            <Card className="widgetCard cardShadow" id="parent_OffsetCarbonFootprint">
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }} align="center">
                    Offset Your Carbon Footprint
                </Typography>
                <Divider light />
                <CardContent sx={{marginTop:3,paddingBottom:4}}>
                <Grid container justifyContent="center" alignItems="center" mb={2}>
                <Grid item md={3} sm={12} xs={12}>
                </Grid>
                <Grid item md={6} sm={8} xs={12}>
                    <Typography fontWeight={800} marginBottom={4} variant="h5" align="center">
                        Offset in the last 12 months
                    </Typography>
                    <Progress
                        startNumber={this.state.progressStart}
                        endNumber={this.state.progressEnd}
                        startText={"out of"}
                        endText={"tonn of CO2"}
                        color={wyzrTheme.palette.primary.light}
                    />
                </Grid>
                <Grid item md={3} sm={12} xs={12}>
                    <Box textAlign={{xs:"center", md:"right"}} mt={{xs:4, md:0}}>
                        <Button sx={{ fontSize: "0.9rem", padding: "6px 22px" }} onClick={this.openOffsetList} size="small" variant="outlined" endIcon={<ChevronRightIcon />}>
                        See your offsets
                        </Button>
                    </Box>
                </Grid>
                </Grid>
                </CardContent>
                <Divider />
                <CardContent sx={{paddingTop:4}}>
                    <Typography  align="center" variant="h5" marginBottom={4} fontWeight={800}>
                        Offset Projects
                    </Typography>

                     <Grid container columnSpacing={4} rowGap={2}>
                        {this.state.isReady && offsetProjects.map((el, index) => (
                            <Grid item sm={6} display={"flex"}>
                                <OffsetProjectCard project={el} images={images}/>
                            </Grid>
                        ))}
                    </Grid> 
                </CardContent>
                {this.state.showList ?
            <CarbonFootprintOffsetList toggleHandler={this.openOffsetList} /> :null 
            }
            </Card>
        )
    }
}
